import { getVipInfo } from "@/api/operate";
import { formatData, filterOperateLevel } from "@/utils/format";
import vipAttrProps from "@/config/vip";

export default {
  data() {
    return {
      vipInfo: {},
    };
  },
  methods: {
    getVipInfo() {
      getVipInfo({
        search: JSON.stringify(
          this.isRegion
            ? {
                Shop: this.info.region,
              }
            : { Region: this.info.region }
        ),
      }).then((rows) => {
        this.vipInfo = formatData(rows, vipAttrProps);
      });
    },
  },
};
